import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type LastUpdatedInfoProps = {
  isSaving: boolean;
  lastSaveTime: Date | null;
  lastUpdatedDate?: string;
  savingText?: string;
  labelText?: string;
};

export const LastUpdatedInfo = ({
  isSaving,
  lastSaveTime,
  lastUpdatedDate,
  savingText,
  labelText,
}: LastUpdatedInfoProps) => {
  const { t } = useTranslation();
  const actualSavingText = savingText || t('SAVING');
  const actualLabelText = labelText || t('LAST_SAVED');

  const formatDateTime = (date: Date) => {
    return date.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const getFormattedDate = () => {
    if (lastSaveTime) {
      return formatDateTime(lastSaveTime);
    }

    if (lastUpdatedDate) {
      const dateStr = lastUpdatedDate;
      const utcDateStr = dateStr.endsWith("Z") ? dateStr : `${dateStr}Z`;
      const utcDate = new Date(utcDateStr);
      return formatDateTime(utcDate);
    }

    return "";
  };

  if (isSaving) {
    return (
      <>
        <Loader2 className="h-4 w-4 animate-spin" />
        {actualSavingText}
      </>
    );
  }

  const formattedDate = getFormattedDate();

  return (
    <>
      {actualLabelText} {formattedDate || t('NEVER')}
    </>
  );
};
